<template lang="html">
  <div>

    <div
      class="alert alert-light d-block mt-4"
      role="alert">
      <p class="alert-heading mt-2">{{ __('please_select_nominations_welcome') }}</p>
      <p :class="{'ml-3': true, 'text-success': targetBossCount <= actualBossCount}"><small><i class="fas fa-user"/> <strong>{{ bossName }}</strong> - {{ __('at_least_number_needed_number_chose', [{ target: targetBossCount }, { actual: actualBossCount }]) }}</small></p>
      <p :class="{'ml-3': true, 'text-success': targetPeerCount <= actualPeerCount}"><small><i class="fas fa-user"/> <strong>{{ peerName }}</strong> - {{ __('at_least_number_needed_number_chose', [{ target: targetPeerCount }, { actual: actualPeerCount }]) }}</small></p>
      <p :class="{'ml-3': true, 'text-success': targetReportCount <= actualReportCount}"><small><i class="fas fa-user"/> <strong>{{ reportName }}</strong> - {{ __('at_least_number_needed_number_chose', [{ target: targetReportCount }, { actual: actualReportCount }]) }}</small></p>
    </div>

    <server-form
      v-slot="slotProps"
      :form-action="formAction"
      :form="form"
      :submit-btn="{text: targetsReached ? __('save_and_send_nominations') : __('complete_nominations_to_save')}"
      :validate-from-start="true">

      <div
        v-for="(nomination, key) in form.nominations"
        :key="key"
        class="row">

        <div class="col-md-12">
          <h3 class="text-dark mb-0 mt-3">{{ __('observer_title') }} {{ key + 1 }}</h3>
        </div>

        <div class="col-md-6 col-xl-4">
          <my360Input
            :form="form"
            :error-bag="slotProps.errors"
            :label="__('label_name')"
            :generic-error-msg="__('feedback_nomination_name')"
            :prop="`nominations.${key}.name`"
            :name="`nominations[${key}][name]`"
            :validation-name="`Name ${key+1}`"
            :autofocus="key === 0"
            autocomplete="new-password"
            class="vue-input-white"
            required />
        </div>

        <div class="col-md-6 col-xl-4">
          <my360Input
            :form="form"
            :error-bag="slotProps.errors"
            :label="__('label_email')"
            :generic-error-msg="__('feedback_nomination_email')"
            :prop="`nominations.${key}.email`"
            :name="`nominations[${key}][email]`"
            :validation-name="`Email ${key+1}`"
            pattern="[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-z]{2,}$"
            autocomplete="new-password"
            class="vue-input-white"
            type="email"
            required />
        </div>

        <div class="col-md-6 col-xl-3">
          <my360Select
            :form="form"
            :error-bag="slotProps.errors"
            :label="__('label_role')"
            :generic-error-msg="__('feedback_nomination_role')"
            :options="roles"
            :prop="`nominations.${key}.type`"
            :name="`nominations[${key}][type]`"
            :validation-name="`Role ${key+1}`"
            class="vue-input-white"
            required />
        </div>

        <div class="col-md-1">
          <div class="form-group my-3">
            <label class="text-light-grey">Delete</label>
            <button
              type="button"
              class="btn btn-danger btn-sm"
              title="Remove Observer"
              @click="form.nominations.splice(form.nominations.indexOf(form.nominations[key]), 1)"><i class="far fa-user-times" /></button>
          </div>
        </div>

      </div>

      <button
        type="button"
        class="btn btn-outline-secondary btn-sm"
        @click="form.nominations.push({type: ''})">{{ __('btn_add_observer') }} <i class="far fa-user-plus" />
      </button>

      <div
        v-if="targetsReached"
        class="mt-4">
        <h3 class="text-dark"><strong>{{ __('happy_with_your_network_title') }}</strong></h3>
        <p>{{ __('happy_with_your_network_intro') }}</p>

        <p class="mt-2"><em>{{ __('happy_with_your_network_please_note') }}</em></p>
      </div>
    </server-form>
  </div>
</template>

<script>
import formAction from '../mixins/formAction'
import filter from 'lodash.filter'

export default {
  name: 'SurveyNominations',

  mixins: [formAction],

  props: {
    roles: {
      type: Array,
      required: true
    },

    targetBossCount: {
      type: Number,
      required: true
    },

    targetPeerCount: {
      type: Number,
      required: true
    },

    targetReportCount: {
      type: Number,
      required: true
    },

    observersNeededThreshold: {
      type: Number,
      required: true
    }
  },

  data () {
    return {
      form: {
        nominations: [
          {
            name: '',
            email: '',
            type: ''
          }
        ]
      },
      errors: {},
      formWasSubmitted: false
    }
  },

  computed: {
    bossName () {
      var role = filter(this.roles, (role) => { return role.value === 'RATING_BOSS' })[0]
      if (role) {
        return role.label
      }
    },

    peerName () {
      var role = filter(this.roles, (role) => { return role.value === 'RATING_PEER' })[0]
      if (role) {
        return role.label
      }
    },

    reportName () {
      var role = filter(this.roles, (role) => { return role.value === 'RATING_REPORT' })[0]
      if (role) {
        return role.label
      }
    },

    actualBossCount () {
      return filter(this.form.nominations, (n) => { return n.type === 'RATING_BOSS' }).length
    },

    actualPeerCount () {
      return filter(this.form.nominations, (n) => { return n.type === 'RATING_PEER' }).length
    },

    actualReportCount () {
      return filter(this.form.nominations, (n) => { return n.type === 'RATING_REPORT' }).length
    },

    bossTargetReached () {
      return this.actualBossCount >= this.targetBossCount
    },

    peerTargetReached () {
      return this.actualPeerCount >= this.targetPeerCount
    },

    reportTargetReached () {
      return this.actualReportCount >= this.targetReportCount
    },

    targetsReached () {
      return (this.bossTargetReached && this.peerTargetReached && this.reportTargetReached) && (this.form.nominations.length >= this.observersNeededThreshold)
    }
  }
}
</script>

<style lang="css">
  .delete_btn {
    position: absolute;
    bottom: 25px;
    left: 0px;
  }
</style>
